<script setup>
import { computed, nextTick, ref, watch } from "vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonLoadingButton from "@/components/ArgonLoadingButton.vue";

const props = defineProps({
  destinationName: { type: String, default: "" },
  destinationAddress: { type: String, default: "" },
  destinationAddressError: { type: Boolean, default: false },
  observations: { type: String, default: "" },
  isSubmitting: { type: Boolean, default: false },
  isModification: { type: Boolean, default: false },
  disableSubmit: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false },
});

const notesTextarea = ref(null);
watch(
  () => props.isActive,
  (active) => {
    if (active) nextTick(() => notesTextarea.value?.focus());
  }
);

const emit = defineEmits([
  "update:destinationName",
  "update:destinationAddress",
  "update:observations",
  "prev",
  "submit",
]);

const destinationNameModel = computed({
  get: () => props.destinationName,
  set: (value) => emit("update:destinationName", value),
});
const destinationAddressModel = computed({
  get: () => props.destinationAddress,
  set: (value) => emit("update:destinationAddress", value),
});
const observationsModel = computed({
  get: () => props.observations,
  set: (value) => emit("update:observations", value),
});

const submitLabel = computed(() => {
  if (!props.isSubmitting) return "Continuar";
  return props.isModification ? "Guardando..." : "Generando...";
});
</script>

<template>
  <div
    class="multisteps-form__panel js-active p-2 position-relative bg-white rounded-3"
    data-animation="FadeIn"
  >
    <div class="d-flex flex-column" style="height: 420px; overflow-y: auto; overflow-x: hidden;">
      <div class="text-center mb-3">
        <p class="mb-0">Revisa los datos de destino</p>
      </div>

      <div class="row modal-form-row">
        <div class="modal-form-label">
          <label for="deca-destination-name" class="col-form-label">
            Nombre
          </label>
        </div>
        <div class="col">
          <argon-input
            id="deca-destination-name"
            v-model="destinationNameModel"
            type="text"
            :max-length="120"
          />
        </div>
      </div>

      <div class="row modal-form-row">
        <div class="modal-form-label">
          <label for="deca-destination-address" class="col-form-label required">
            Dirección
          </label>
        </div>
        <div class="col">
          <argon-input
            id="deca-destination-address"
            v-model="destinationAddressModel"
            type="text"
            :max-length="180"
            :error="destinationAddressError"
          />
        </div>
      </div>

      <div class="row modal-form-row mb-0">
        <div class="modal-form-label">
          <label for="deca-notes" class="col-form-label">Notas</label>
        </div>
        <div class="col">
          <textarea
            id="deca-notes"
            ref="notesTextarea"
            v-model="observationsModel"
            class="form-control"
            rows="3"
            maxlength="300"
          ></textarea>
        </div>
      </div>

      <div class="d-flex mt-auto">
        <argon-button
          class="mb-0 btn-icon-only"
          color="primary"
          variant="outline"
          size="xs"
          aria-label="Anterior"
          @click.prevent="emit('prev')"
        >
          <span class="btn-inner--icon">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>
          </span>
        </argon-button>
        <argon-loading-button
          class="ms-auto mb-0 btn-xs"
          color="primary"
          variant="gradient"
          :label="submitLabel"
          :loading="isSubmitting"
          :disable-button="disableSubmit"
          @click="emit('submit')"
        />
      </div>
    </div>
  </div>
</template>
